import { Input } from 'antd';
import { SetStateAction, useState } from 'react';

import { Button, Modal } from '@suntex.fim/ui';

/**
 * A promise-based prompt modal — shows an input dialog and resolves with the
 * entered value when confirmed, or `null` when cancelled.
 */
export function useCustomPrompt() {
  const [visible, setVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [resolveFn, setResolveFn] = useState<
    ((value: string | null) => void) | null
  >(null);
  const [text, setText] = useState('');

  const openPrompt = (promptText?: string): Promise<string | null> => {
    return new Promise((resolve) => {
      setResolveFn(() => resolve);
      setText(promptText ?? '');
      setVisible(true);
    });
  };

  const handleInputChange = (e: {
    target: { value: SetStateAction<string> };
  }) => {
    setInputValue(e.target.value);
  };

  const handleCancel = () => {
    setVisible(false);
    setInputValue('');
    resolveFn?.(null);
  };

  const handleConfirm = () => {
    resolveFn?.(inputValue);
    setVisible(false);
    setInputValue('');
  };

  const CustomPrompt = (
    <Modal
      title={text || 'Please enter something:'}
      open={visible}
      onCancel={handleCancel}
      footer={
        <>
          <Button
            shape="round"
            intent="secondary"
            key="back"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            shape="round"
            intent="primary"
            key="submit"
            onClick={handleConfirm}
            disabled={!inputValue}
          >
            Confirm
          </Button>
        </>
      }
    >
      <Input value={inputValue} onChange={handleInputChange} />
    </Modal>
  );

  return { openPrompt, CustomPrompt };
}
